module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-autocomplete"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.clickOutside),
      expression: "clickOutside"
    }],
    staticClass: "autocomplete"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [(_vm.displayIcon) ? _c('div', {
    staticClass: "search-autocomplete-icon",
    on: {
      "click": _vm.keyEnter
    }
  }, [_c('i', {
    staticClass: "fas fa-search fa-fw"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInput),
      expression: "userInput"
    }],
    class: {
      classname: _vm.classname, 'has-icon': _vm.displayIcon
    },
    attrs: {
      "id": _vm.id,
      "name": "search",
      "type": "search",
      "placeholder": "I'm looking for ...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userInput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userInput = $event.target.value
      }, _vm.fetchSearchSuggestions],
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "escape", undefined, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEscape($event)
      }],
      "!keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        _vm.keyUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        _vm.keyDown($event)
      }]
    }
  }), _vm._v(" "), (_vm.fetchingDetails) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "alt": "Loading while fetching the search result selected",
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3915/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.displaySuggestions) ? _c('div', {
    staticClass: "suggestions"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "suggestion-loading"
  }, [_c('img', {
    attrs: {
      "alt": "Loading while fetching suggestions",
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3915/dist/assets/img/loading-three-dots.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.suggestions.length > 0) ? _c('div', {
    staticClass: "suggestion-list",
    attrs: {
      "id": "search-suggestion-list"
    }
  }, _vm._l((_vm.suggestions), function(p) {
    return _c('div', {
      staticClass: "suggestion-item",
      class: {
        'item-active': _vm.cursor === p.index
      },
      attrs: {
        "id": 'search-suggestion-item-' + p.index
      },
      on: {
        "click": function($event) {
          _vm.selectSearchSuggestion(p.label)
        },
        "mouseover": function($event) {
          _vm.cursor = p.index
        }
      }
    }, [_vm._v("\n          " + _vm._s(p.label) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.suggestions.length == 0) ? _c('div', {
    staticClass: "suggestion-list"
  }, [_c('div', {
    staticClass: "suggestion-item empty",
    on: {
      "click": function($event) {
        _vm.selectSearchSuggestion(_vm.userInput)
      }
    }
  }, [_vm._v("\n          No Suggestions\n        ")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.displaySearchButton) ? _c('button', {
    staticClass: "search-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectSearchSuggestion(_vm.userInput)
      }
    }
  }, [_vm._v("\n    Search\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5799bdc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=tqk19250jg!./~/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./src/components/search/SearchAutocomplete.vue
// module id = 724
// module chunks = 0